import type { Event } from '@/types/event';
import {
    ReportEventType,
    type ReportEvent,
    type ReportEventDetail,
} from '@/types/report';
import type { FullSource } from '@/types/source';
import { SourceType } from '@/types/source';

const EXPORTABLE_SOURCE_TYPES = new Set([SourceType.FILE, SourceType.CAMERA]);

function exportableSourceType(sourceType: SourceType | undefined): boolean {
    return sourceType === undefined || EXPORTABLE_SOURCE_TYPES.has(sourceType);
}

export function exportableEvent(event: Event, source?: FullSource): boolean {
    return exportableSourceType(event.sourceType ?? source?.type);
}

export function exportableReportEvent(
    event: ReportEvent | ReportEventDetail,
): boolean {
    const eventType = 'eventType' in event ? event.eventType : event.type;
    if (eventType === ReportEventType.CUSTOM) {
        return event.sourceType === SourceType.FILE;
    }
    return exportableSourceType(event.sourceType);
}
